import { combineReducers } from "redux";
import fullPageLoaderReducer from "../features/FullPageLoader/FullPageLoaderSlice";
import loginSliceReducer from "../features/login/LoginSlice";
import setConfigurationReducer from "../features/configuration/ConfigurationSlice";

export default combineReducers({
  loginSlice: loginSliceReducer,
  fullPageLoaderSlice: fullPageLoaderReducer,
  configurationSlice : setConfigurationReducer
});
